import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
import { CONNECTED_EMAIL_DATA_ACCESS } from '../../constants/Scopes';
export const hasConnectedEmailDataAccess = createSelector(getScopes, scopes => scopes.includes(CONNECTED_EMAIL_DATA_ACCESS));